module.exports = __webpack_public_path__ + "media/Ring 2.acdf002c.mp3";